import CONFIG_KEYS from "../config";
import { ApiClient, NotificationItemModel } from "../generated/api";
import { customFetch } from "../middlewares/custom-fetch";

export class NotificationService {

  private api: ApiClient;

  constructor(navigate?: (url: string) => void) {
    this.api = new ApiClient(CONFIG_KEYS.baseUrl, {
      fetch: customFetch
    });
  }

  public async SetSeen(token: string): Promise<NotificationItemModel> {
    return await this.api.setSeen(token);
  }

  public async GetNotifications(pageNumber?: number, pageSize?: number): Promise<NotificationItemModel[]> {
    try {
      return await this.api.getNotificationsList(pageNumber, pageSize) ?? [];
    } catch {
      return [];
    }
  }

  public async MarkAllSeen(userToken: string): Promise<void> {
    await this.api.markAllSeen();
  }
}
